var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.pricing && _vm.isOwner
    ? _c(
        "w-row",
        { style: { width: "100%", margin: "0px auto", marginTop: "25px" } },
        [
          _vm.showCreateSubscriptionInfo
            ? _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-info",
                    {
                      staticClass: "mt",
                      attrs: {
                        text: "",
                        "ico-lib": "fas",
                        ico: "info-circle",
                        border: "",
                        warning: "",
                      },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.$ct("upgrade-info"))),
                      _c(
                        "w-link",
                        {
                          staticClass: "mls mrs",
                          attrs: { to: "/account/renew" },
                        },
                        [_vm._v(_vm._s(_vm.$ct("upgrade-link")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showPricing
            ? _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-all-price-items", {
                    attrs: {
                      pricing: _vm.pricing,
                      "selected-frequency-type": _vm.selectedFrequencyType,
                      "current-plan": _vm.currentPlan,
                      "has-no-plan": _vm.hasNoPlan,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.showFrequencySwitch
            ? _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "" } },
                    [
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          style: { flexGrow: 0 },
                          attrs: { flat: "" },
                          on: {
                            click: function ($event) {
                              return _vm.logout()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("logout")) + " ")]
                      ),
                      _c("w-spacer"),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showFrequencySwitch
            ? _c("w-col", { attrs: { xs: "12" } })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }